import React from 'react'

function SparkIcon() {
  return (
    <svg
      width='22'
      height='23'
      viewBox='0 0 22 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3.5 21.5V16.5M3.5 6.5V1.5M1 4H6M1 19H6M12 2.5L10.2658 7.00886C9.98381 7.74209 9.84281 8.10871 9.62353 8.41709C9.42919 8.6904 9.1904 8.92919 8.91709 9.12353C8.60871 9.3428 8.24209 9.48381 7.50886 9.76582L3 11.5L7.50886 13.2342C8.24209 13.5162 8.60871 13.6572 8.91709 13.8765C9.1904 14.0708 9.42919 14.3096 9.62353 14.5829C9.84281 14.8913 9.98381 15.2579 10.2658 15.9911L12 20.5L13.7342 15.9911C14.0162 15.2579 14.1572 14.8913 14.3765 14.5829C14.5708 14.3096 14.8096 14.0708 15.0829 13.8765C15.3913 13.6572 15.7579 13.5162 16.4911 13.2342L21 11.5L16.4911 9.76582C15.7579 9.48381 15.3913 9.3428 15.0829 9.12353C14.8096 8.92919 14.5708 8.6904 14.3765 8.41709C14.1572 8.10871 14.0162 7.74209 13.7342 7.00886L12 2.5Z'
        stroke='#6267AC'
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default SparkIcon
